import React, { useEffect, useState } from "react";
import * as S from "./VerVendaStyle"; // Certifique-se que o arquivo de estilo está na mesma pasta
import { FaTimes, FaEdit, FaCheck, FaBan, FaMoneyBillWave } from "react-icons/fa";
import { consultorService } from "../../Services/consultorService"; 
import { useMessage } from "../../Context/MessageContext"; 
import Loading from "../Loader"; 

export default function VerVenda({ saleId, handleClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Estados de edição
  const [isEditing, setIsEditing] = useState(false);
  const [newValue, setNewValue] = useState("");
  const [saving, setSaving] = useState(false);
  
  const { showMessage } = useMessage();

  useEffect(() => {
    if (saleId) {
      fetchSaleData();
    }
  }, [saleId]);

  const fetchSaleData = async () => {
    setLoading(true);
    try {
      const response = await consultorService.getSaleById(saleId);
      setData(response);
      setNewValue(response.value);
    } catch (error) {
      console.error(error);
      showMessage("Erro ao carregar dados da venda.", "error");
      // NÃO chame handleClose() aqui, senão o usuário não vê que deu erro.
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateValue = async () => {
    if (!newValue || isNaN(newValue)) {
      showMessage("Insira um valor válido.", "warning");
      return;
    }

    setSaving(true);
    try {
      await consultorService.updateSaleValue(data.id, parseFloat(newValue));
      showMessage("Valor atualizado com sucesso!", "success");
      
      // Atualiza o dado localmente
      setData((prev) => ({ ...prev, value: parseFloat(newValue) }));
      setIsEditing(false);
    } catch (error) {
      console.error(error);
      showMessage("Erro ao atualizar valor.", "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <S.Overlay onClick={handleClose}>
      <S.ModalContainer onClick={(e) => e.stopPropagation()}>
        <S.Header>
          <h2>
            <FaMoneyBillWave /> Detalhes da Venda #{data && data.id ? data.id : ""}, Contrato #{saleId}
          </h2>
          <S.CloseButton onClick={handleClose}>
            <FaTimes />
          </S.CloseButton>
        </S.Header>

        {/* O Loading agora acontece DENTRO do modal */}
        {loading ? (
          <div style={{ padding: '40px', display: 'flex', justifyContent: 'center' }}>
            <Loading load={true} />
          </div>
        ) : data ? (
          <S.Content>
            <S.InfoGroup>
              <label>Cliente</label>
              <span>{data.clientName}</span>
              <span style={{ fontSize: "12px", opacity: 0.7 }}>
                CPF: {data.clientCpfCnpj}
              </span>
            </S.InfoGroup>

            <S.InfoGroup>
              <label>Consultor Responsável</label>
              <span>{data.consultant?.name || "N/A"}</span>
              <span style={{ fontSize: "12px", opacity: 0.7 }}>
                Email: {data.consultant?.email}
              </span>
            </S.InfoGroup>

            <S.Divider />

            <S.InfoGroup>
              <label>Descrição / Plataforma</label>
              <span>{data.description || "Sem descrição"}</span>
              <span style={{ color: "#E6AA3A" }}>{data.platformId}</span>
            </S.InfoGroup>

            <S.InfoGroup>
              <label>Data de Criação</label>
              <span>{new Date(data.dateCreated).toLocaleString()}</span>
            </S.InfoGroup>

            <S.Divider />

            <S.ValueEditor>
              <label>Valor da Venda</label>
              {!isEditing ? (
                <S.ValueDisplay>
                  <span className="value">
                    {data.value?.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </span>
                  <S.EditButton onClick={() => setIsEditing(true)}>
                    <FaEdit /> Alterar
                  </S.EditButton>
                </S.ValueDisplay>
              ) : (
                <S.EditForm>
                  <input
                    type="number"
                    value={newValue}
                    onChange={(e) => setNewValue(e.target.value)}
                    placeholder="Novo valor..."
                    autoFocus
                  />
                  <S.ActionButtons>
                    <button
                      className="save"
                      onClick={handleUpdateValue}
                      disabled={saving}
                    >
                      {saving ? "..." : <FaCheck />}
                    </button>
                    <button
                      className="cancel"
                      onClick={() => {
                        setIsEditing(false);
                        setNewValue(data.value);
                      }}
                    >
                      <FaBan />
                    </button>
                  </S.ActionButtons>
                </S.EditForm>
              )}
            </S.ValueEditor>
          </S.Content>
        ) : (
           <div style={{ padding: '20px', color: 'white', textAlign: 'center' }}>
             Não foi possível carregar os dados.
           </div>
        )}
      </S.ModalContainer>
    </S.Overlay>
  );
}